import { Routes } from '@angular/router';
import { NotFoundComponent } from './notFound.component';

/**
 * Defines the routes for the NotFoundComponent.
 */
export default [
    {
        path     : '',
        component: NotFoundComponent
    }
] as Routes;
